module.exports = __webpack_public_path__ + "static/media/list.b133df70.svg";